(function () {
  "use strict";

  var STORAGE_KEY = "dreeporasia_jt_verified_ph_address_v1";
  var BLOCK_NON_DELIVERABLE = true;
  var CHECKOUT_SELECTORS = [
    'form[action="/cart"] [name="checkout"]',
    'form[action^="/cart"] [name="checkout"]',
    'button[name="checkout"]',
    'input[name="checkout"]',
    'a[href="/checkout"]',
    'a[href^="/checkout?"]',
    '[data-testid="Checkout-button"]',
    ".cart__checkout-button"
  ].join(",");

  var data = window.JT_PH_ADDRESS_DATA || { regions: [] };
  var state = {
    region: null,
    province: null,
    city: null,
    barangay: null,
    isSubmitting: false,
    nextCheckoutUrl: "/checkout"
  };
  var els = {};

  function clean(value) {
    return String(value || "").trim().replace(/\s+/g, " ");
  }

  function titleCase(value) {
    return clean(value).toLowerCase().replace(/\b[a-z]/g, function (char) {
      return char.toUpperCase();
    });
  }

  function option(value, label, disabled) {
    var node = document.createElement("option");
    node.value = value;
    node.textContent = label;
    if (disabled) node.disabled = true;
    return node;
  }

  function resetSelect(select, placeholder) {
    select.innerHTML = "";
    select.appendChild(option("", placeholder));
  }

  function fillSelect(select, rows, placeholder, getLabel, isDisabled) {
    resetSelect(select, placeholder);
    rows.forEach(function (row, index) {
      select.appendChild(option(String(index), getLabel(row), isDisabled && isDisabled(row)));
    });
  }

  function showError(message) {
    els.error.textContent = message;
    els.error.classList.add("is-visible");
  }

  function clearError() {
    els.error.textContent = "";
    els.error.classList.remove("is-visible");
  }

  function setLoading(isLoading) {
    state.isSubmitting = isLoading;
    els.submit.disabled = isLoading;
    els.submit.textContent = isLoading ? "Saving..." : "Continue to checkout";
  }

  function loadSavedAddress() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) || "null");
    } catch (error) {
      return null;
    }
  }

  function saveAddress(address) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(address));
    } catch (error) {}
  }

  function setHelper() {
    var source = data.source ? "J&T address guide" : "address guide";
    els.helper.textContent = "Address list source: " + source + ". Door-to-door unavailable barangays cannot continue to checkout.";
  }

  function syncRegion() {
    clearError();
    state.region = data.regions[Number(els.region.value)] || null;
    state.province = null;
    state.city = null;
    state.barangay = null;

    if (!state.region) {
      resetSelect(els.province, "Select province");
      resetSelect(els.city, "Select city / municipality");
      resetSelect(els.barangay, "Select barangay");
      els.province.disabled = true;
      els.city.disabled = true;
      els.barangay.disabled = true;
      return;
    }

    fillSelect(els.province, state.region.provinces || [], "Select province", function (province) {
      return province.name + rateSuffix(province);
    });
    els.province.disabled = false;
    resetSelect(els.city, "Select city / municipality");
    resetSelect(els.barangay, "Select barangay");
    els.city.disabled = true;
    els.barangay.disabled = true;
  }

  function syncProvince() {
    clearError();
    state.province = state.region && state.region.provinces[Number(els.province.value)] || null;
    state.city = null;
    state.barangay = null;

    if (!state.province) {
      resetSelect(els.city, "Select city / municipality");
      resetSelect(els.barangay, "Select barangay");
      els.city.disabled = true;
      els.barangay.disabled = true;
      return;
    }

    fillSelect(els.city, state.province.cities || [], "Select city / municipality", function (city) {
      return city.name + rateSuffix(city);
    });
    els.city.disabled = false;
    resetSelect(els.barangay, "Select barangay");
    els.barangay.disabled = true;
  }

  function syncCity() {
    clearError();
    state.city = state.province && state.province.cities[Number(els.city.value)] || null;
    state.barangay = null;

    if (!state.city) {
      resetSelect(els.barangay, "Select barangay");
      els.barangay.disabled = true;
      return;
    }

    fillSelect(
      els.barangay,
      state.city.barangays || [],
      "Select barangay",
      function (barangay) {
        return barangay.name + (barangay.doorToDoor ? "" : " - No door-to-door");
      },
      function (barangay) {
        return BLOCK_NON_DELIVERABLE && !barangay.doorToDoor;
      }
    );
    els.barangay.disabled = false;
  }

  function syncBarangay() {
    clearError();
    state.barangay = state.city && state.city.barangays[Number(els.barangay.value)] || null;
    if (state.barangay && !state.barangay.doorToDoor) {
      showError("This barangay is marked by J&T as not available for door-to-door delivery.");
    }
  }

  function rateSuffix(node) {
    return node && node.rates && node.rates.length ? " (" + node.rates.join(", ") + ")" : "";
  }

  function selectedAddress() {
    var street = clean(els.street.value);
    var phone = clean(els.phone.value);
    var province = state.province ? state.province.name : "";
    var cityRaw = state.city ? state.city.name : "";
    var cityDisplay = state.city ? state.city.displayName || state.city.name : "";
    var barangay = state.barangay ? state.barangay.name : "";
    var rates = state.city && state.city.rates ? state.city.rates.join(", ") : "";
    var address2 = barangay ? "Barangay " + titleCase(barangay) : "";
    var checkoutCity = titleCase(cityDisplay || cityRaw);
    var checkoutProvince = titleCase(province);
    var fullAddress = [
      street,
      address2,
      titleCase(cityRaw),
      checkoutProvince,
      "Philippines"
    ].filter(Boolean).join(", ");

    return {
      region: state.region ? state.region.name : "",
      rate: rates,
      province: province,
      city: cityRaw,
      cityDisplay: cityDisplay,
      barangay: barangay,
      doorToDoor: !!(state.barangay && state.barangay.doorToDoor),
      street: street,
      phone: phone,
      address1: street,
      address2: address2,
      checkoutCity: checkoutCity,
      checkoutProvince: checkoutProvince,
      fullAddress: fullAddress
    };
  }

  function validateAddress(address) {
    if (!address.region) return "Please select a J&T region.";
    if (!address.province) return "Please select a province.";
    if (!address.city) return "Please select a city or municipality.";
    if (!address.barangay) return "Please select a barangay.";
    if (!address.doorToDoor) return "This barangay is not available for J&T door-to-door delivery.";
    if (address.street.length < 8) return "Please enter house number, street, subdivision, or landmark.";
    if (!/^(\+?63|0)?9\d{9}$/.test(address.phone.replace(/[\s-]/g, ""))) {
      return "Please enter a valid Philippines mobile number, for example 09171234567.";
    }
    return "";
  }

  function saveCartAttributes(address) {
    var attributes = {
      "J&T Verified Region": address.region,
      "J&T Verified Rate Zone": address.rate,
      "J&T Verified Province": address.province,
      "J&T Verified City/Municipality": address.city,
      "J&T Verified Barangay": address.barangay,
      "J&T Door to Door": address.doorToDoor ? "Yes" : "No",
      "J&T Street/Landmark": address.street,
      "J&T Full Address": address.fullAddress,
      "J&T Phone": address.phone
    };

    return fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ attributes: attributes })
    }).then(function (response) {
      if (!response.ok) throw new Error("Could not save address to cart.");
      return response.json();
    });
  }

  function checkoutUrl(address) {
    var url = new URL(state.nextCheckoutUrl || "/checkout", window.location.origin);
    url.searchParams.set("checkout[shipping_address][country]", "Philippines");
    url.searchParams.set("checkout[shipping_address][province]", address.checkoutProvince);
    url.searchParams.set("checkout[shipping_address][city]", address.checkoutCity);
    url.searchParams.set("checkout[shipping_address][address1]", address.address1);
    url.searchParams.set("checkout[shipping_address][address2]", address.address2);
    url.searchParams.set("checkout[shipping_address][phone]", address.phone);
    return url.toString();
  }

  function openModal(nextUrl) {
    clearError();
    state.nextCheckoutUrl = nextUrl || "/checkout";
    document.documentElement.classList.add("ph-address-lock");
    els.overlay.classList.add("is-open");
  }

  function closeModal() {
    els.overlay.classList.remove("is-open");
    document.documentElement.classList.remove("ph-address-lock");
  }

  function submitAddress(event) {
    event.preventDefault();
    if (state.isSubmitting) return;

    clearError();
    var address = selectedAddress();
    var error = validateAddress(address);
    if (error) {
      showError(error);
      return;
    }

    setLoading(true);
    saveCartAttributes(address)
      .then(function () {
        saveAddress(address);
        window.location.href = checkoutUrl(address);
      })
      .catch(function (err) {
        showError(err.message || "Could not save address. Please try again.");
        setLoading(false);
      });
  }

  function interceptCheckout(event) {
    var target = event.target.closest(CHECKOUT_SELECTORS);
    if (!target) return;
    var nextUrl = target.tagName === "A" ? target.href : "/checkout";
    event.preventDefault();
    event.stopPropagation();
    openModal(nextUrl);
  }

  function buildModal() {
    var overlay = document.createElement("div");
    overlay.className = "ph-address-overlay";
    overlay.innerHTML = [
      '<div class="ph-address-modal" role="dialog" aria-modal="true" aria-labelledby="ph-address-title">',
      '  <div class="ph-address-header">',
      '    <div>',
      '      <h2 class="ph-address-title" id="ph-address-title">Confirm your J&T delivery address</h2>',
      '      <p class="ph-address-subtitle">Select the exact Region, Province, City, and Barangay from our J&T delivery guide.</p>',
      '    </div>',
      '    <button class="ph-address-close" type="button" aria-label="Close">&times;</button>',
      '  </div>',
      '  <form class="ph-address-form">',
      '    <div class="ph-address-grid">',
      '      <div class="ph-address-field"><label for="ph-region">J&T Region</label><select id="ph-region" required></select></div>',
      '      <div class="ph-address-field"><label for="ph-province">Province</label><select id="ph-province" required disabled></select></div>',
      '      <div class="ph-address-field"><label for="ph-city">City / Municipality</label><select id="ph-city" required disabled></select></div>',
      '      <div class="ph-address-field"><label for="ph-barangay">Barangay</label><select id="ph-barangay" required disabled></select></div>',
      '      <div class="ph-address-field is-wide"><label for="ph-phone">Mobile number</label><input id="ph-phone" autocomplete="tel" placeholder="09171234567" required></div>',
      '      <div class="ph-address-field is-wide"><label for="ph-street">House no., street, subdivision, landmark</label><textarea id="ph-street" autocomplete="street-address" required></textarea><div class="ph-address-help">Example: Block 2 Lot 5, Sampaguita St., near Jollibee</div></div>',
      '    </div>',
      '    <div class="ph-address-help ph-address-source"></div>',
      '    <div class="ph-address-error" role="alert"></div>',
      '    <div class="ph-address-actions">',
      '      <button class="ph-address-button secondary" type="button" data-close>Cancel</button>',
      '      <button class="ph-address-button primary" type="submit">Continue to checkout</button>',
      '    </div>',
      '  </form>',
      '</div>'
    ].join("");

    document.body.appendChild(overlay);
    els.overlay = overlay;
    els.form = overlay.querySelector("form");
    els.region = overlay.querySelector("#ph-region");
    els.province = overlay.querySelector("#ph-province");
    els.city = overlay.querySelector("#ph-city");
    els.barangay = overlay.querySelector("#ph-barangay");
    els.phone = overlay.querySelector("#ph-phone");
    els.street = overlay.querySelector("#ph-street");
    els.error = overlay.querySelector(".ph-address-error");
    els.helper = overlay.querySelector(".ph-address-source");
    els.submit = overlay.querySelector(".ph-address-button.primary");
    els.close = overlay.querySelector(".ph-address-close");
  }

  function hydrateSavedAddress() {
    var saved = loadSavedAddress();
    if (!saved) return;
    els.phone.value = saved.phone || "";
    els.street.value = saved.street || "";
  }

  function bindEvents() {
    document.addEventListener("click", interceptCheckout, true);
    els.form.addEventListener("submit", submitAddress);
    els.close.addEventListener("click", closeModal);
    els.overlay.querySelector("[data-close]").addEventListener("click", closeModal);
    els.region.addEventListener("change", syncRegion);
    els.province.addEventListener("change", syncProvince);
    els.city.addEventListener("change", syncCity);
    els.barangay.addEventListener("change", syncBarangay);
  }

  function init() {
    if (window.__dreeporasiaJtAddressGuardLoaded) return;
    window.__dreeporasiaJtAddressGuardLoaded = true;
    buildModal();
    bindEvents();
    setHelper();
    fillSelect(els.region, data.regions || [], "Select J&T region", function (region) {
      return region.name + rateSuffix(region);
    });
    resetSelect(els.province, "Select province");
    resetSelect(els.city, "Select city / municipality");
    resetSelect(els.barangay, "Select barangay");
    hydrateSavedAddress();
    if (!data.regions || !data.regions.length) {
      showError("J&T address data was not loaded. Please contact support.");
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
